import Swal from 'sweetalert2';
import {MENSAGEM} from "../config/constantes/constantes";

function exibirMensagem(parametros) {
  if (typeof parametros === "string") {
    parametros = {
      "titulo": parametros,
      "icone": ""
    }
  }
  switch (parametros.tipo) {
    case MENSAGEM.TIPO.SUCESSO :
      parametros.icone = "success"
      break;
    case MENSAGEM.TIPO.ERRO :
      parametros.icone = "error"
      break;
    case MENSAGEM.TIPO.INFO :
      parametros.icone = "error"
      break;
    case MENSAGEM.TIPO.ALERTA :
      parametros.icone = "error"
      break;
    case MENSAGEM.TIPO.PERGUNTA :
      parametros.icone = "error"
      break;
    default:
      if (!parametros.titulo) parametros.titulo = "";
      if (parametros.icone == null) parametros.icone = "info";
      break;
  }
  if (!parametros.texto) parametros.texto = "";
  if (parametros.botaoFechar == null) parametros.botaoFechar = false;
  if (!parametros.posicao) parametros.posicao = "top-end";
  Swal.fire({
    // showClass: {
    //     popup: 'animate__animated animate__fadeIn'
    // },
    hideClass: {
      popup: 'animate__animated animate__fadeOut'
    },
    position: parametros.posicao,
    icon: parametros.icone,
    title: parametros.titulo,
    text: parametros.texto,
    backdrop: false,
    showCloseButton: true,
    showConfirmButton: parametros.botaoFechar,
    timer: 4000,
    allowOutsideClick: false,
    timerProgressBar: true
  })
}

function exibirMensagemSucesso(mensagem) {
  const parametros = {
    "titulo": "Sucesso!",
    "texto": mensagem,
    "tipo": MENSAGEM.TIPO.SUCESSO
  }
  exibirMensagem(parametros)
}

function exibirMensagemErro(mensagem) {
  const parametros = {
    "titulo": mensagem,
    "tipo": MENSAGEM.TIPO.ERRO
  }
  exibirMensagem(parametros)
}

function exibirMensagemInfo(mensagem) {
  const parametros = {
    "texto": mensagem,
    "tipo": MENSAGEM.TIPO.INFO
  }
  exibirMensagem(parametros)
}

function exibirMensagemAlerta(mensagem) {
  const parametros = {
    "titulo": "Atenção!",
    "texto": mensagem,
    "tipo": MENSAGEM.TIPO.ALERTA
  }
  exibirMensagem(parametros)
}

function exibirMensagemPergunta(mensagem) {
  const parametros = {
    "titulo": mensagem,
    "tipo": MENSAGEM.TIPO.PERGUNTA
  }
  exibirMensagem(parametros)
}

export {
  exibirMensagem,
  exibirMensagemSucesso,
  exibirMensagemErro,
  exibirMensagemAlerta,
  exibirMensagemInfo,
  exibirMensagemPergunta
}